import React from 'react';

import './styles.scoped.css';

const TileGrid = ({ columns = 3, children }) => {
  return (
    <div
      className="tile-grid"
      style={{ gridTemplateColumns: `repeat(${columns}, 310px)` }}
    >
      {children}
    </div>
  );
};

export default TileGrid;
